import { render, staticRenderFns } from "./PointStyleDefinition.vue?vue&type=template&id=6227f54e&scoped=true"
import script from "./PointStyleDefinition.vue?vue&type=script&lang=ts"
export * from "./PointStyleDefinition.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PointStyleDefinition.vue?vue&type=style&index=0&id=6227f54e&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6227f54e",
  null
  ,true
)

export default component.exports